import React from "react";

const WellSecured = (props: any) => {
	return <div>WellSecured</div>;
};

export default WellSecured;
